import { render, staticRenderFns } from "./addRule.vue?vue&type=template&id=59b4e00d&scoped=true&"
import script from "./addRule.vue?vue&type=script&lang=js&"
export * from "./addRule.vue?vue&type=script&lang=js&"
import style0 from "./addRule.vue?vue&type=style&index=0&id=59b4e00d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b4e00d",
  null
  
)

export default component.exports